import { getLabel } from "./statuses";

const campaigns = {
    statuses: [
        { value: "CREATED", label: getLabel("CREATED") },
        { value: "ACTIVE", label: getLabel("ACTIVE") },
        { value: "INACTIVE", label: getLabel("INACTIVE") },
        { value: "FINISHED", label: getLabel("FINISHED") },
    ],
};

export default campaigns;
